import { useAuth } from "../routes/authContext";
import { UserRoles } from "../constants/userRoles";

  export const hasRole = (userRoleLevel, allowedRoles) => {
    if (!userRoleLevel || !allowedRoles || !Array.isArray(allowedRoles)) {
      return false;
    }
    return allowedRoles.includes(userRoleLevel);
  };
  
  export const useRoles = () => {
    const { user } = useAuth();
  
    const userRoleLevel = user?.roleLevel || null;
  
    const isSuperAdmin = hasRole(userRoleLevel, [UserRoles.SUPER_ADMIN]);
    const isAdmin = hasRole(userRoleLevel, [UserRoles.ADMIN]);
    const isUser = hasRole(userRoleLevel, [UserRoles.USER]);
    const isGuest = hasRole(userRoleLevel, [UserRoles.GUEST_USER]);
  
    return {
      isSuperAdmin,
      isAdmin,
      isUser,
      isGuest,
      userRoleLevel,
    };
  };